import React from 'react';
import "../assets/styles/blogList.scss";
import { useNavigate } from 'react-router-dom';

const BlogPosts = ({ postNums, type="grid" }) => {

  const navigate = useNavigate();

  const blogPosts = [
    {
      img: require('../assets/images/blog-banner.png'),
      title: 'راه‌اندازی وب‌سایت وطن',
      desc: 'حمل‌ونقل وطن، در راستای ارتقا کیفی خدمات خود به مشتریان، اقدام به راه‌اندازی خدمتی جدید برای ارسال ویژه بار با عنوان وطن اکسپرس نموده است. این سرویس که از مزایای خاصی از جمله حمل سریع‌تر و ایمن‌تر برخوردار است، به صورت درب‌-به-درب بوده و نیاز مشتری را از حمل بار تا باربری بی‌نیاز می‌کند.',
      tag:'اخبار وطن',
      date:'۴ آبان ۱۴۰۲'
    },

    {
      img: require('../assets/images/blog-banner.png'),
      title: 'حمل و نقل وطن',
      desc: 'این یک متن آزمایشی حمل و نقل وطن است',
      tag:'اخبار وطن',
      date:'۴ آبان ۱۴۰۲'
    },

    {
      img: require('../assets/images/blog-banner.png'),
      title: 'راه‌اندازی وب‌سایت وطن',
      desc: 'حمل‌ونقل وطن، در راستای ارتقا کیفی خدمات خود به مشتریان، اقدام به راه‌اندازی خدمتی جدید برای ارسال ویژه بار با عنوان وطن اکسپرس نموده است. این سرویس که از مزایای خاصی از جمله حمل سریع‌تر و ایمن‌تر برخوردار است، به صورت درب‌-به-درب بوده و نیاز مشتری را از حمل بار تا باربری بی‌نیاز می‌کند.',
      tag:'اخبار وطن',
      date:'۴ آبان ۱۴۰۲'
    },
    // Add more blog posts as needed
  ];

  const showPost = (blog) => {
    navigate('/singleBlog', {
      state: {
        blog,
      }
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });

  }

  // If postNums is provided and is a valid number, slice the blogPosts array to get the latest posts
  const latestPosts = postNums ? blogPosts.slice(0, postNums) : blogPosts;

  return (
    <div className={type == "grid" ? 'blog-posts-list' : 'blog-column-list'}>
      {latestPosts.map((blog, index) => (
        <div 
        onClick={() => showPost(blog)}
        className="blog-post" key={index}>
          <img src={blog.img} alt="blog-title" />
          <div className='blog-texts'>
          <h5>{blog.title}</h5>
          <p>{blog.desc}</p>
          {
            type == 'list' ? (
              <span>{blog.date}</span>
            ): null
          }
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogPosts;
